import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource-variable/inter'; // unified design system: self-hosted Inter (no external CDN)
import './index.css';
import './i18n/config';
import App from './App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
